/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_Hslope_Target_LabelInputs */



/**
* | output |
* | --- |
* | "Target average temperature rise speed of thermostatic valves:" |
*
* @param {Heating_Curve_Hslope_Target_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_hslope_target_label = /** @type {((inputs?: Heating_Curve_Hslope_Target_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Hslope_Target_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Target average temperature rise speed of thermostatic valves:")
	return /** @type {LocalizedString} */ ("Objectif de vitesse de montée en température moyenne des tête th.:")
});